$(window).on('scroll', function() {
  const availabilityBar = $('.availabilityBar__progress');

  if (availabilityBar.length > 0) {
    const segments = availabilityBar.first().children();
    const fillInSpeed = availabilityBar.attr('data-fill-in-speed');
    const fillOutSpeed = availabilityBar.attr('data-fill-out-speed');

    const alreadyAnimated = availabilityBar.data('alreadyAnimated');
  
    if (!alreadyAnimated && checkIsInViewport(availabilityBar)) {
      availabilityBar.data('alreadyAnimated', true);
  
      let index = 0;
      const fadeInInterval = setInterval(() => {
        if (index < segments.length) {
          segments.eq(index).fadeIn();
          index++;
        } else {
          clearInterval(fadeInInterval);
  
          const fadeOutInterval = setInterval(() => {
            if (index > 2) {
              index--;
              segments.eq(index).fadeOut();
            } else {
              clearInterval(fadeOutInterval);
              segmentsBlinkAndTextChange();
            }
          }, fillOutSpeed);
        }
      }, fillInSpeed);
    }
  }
});

function segmentsBlinkAndTextChange() {
  const blinkTimeMS = +`${$('.availabilityBar__progress').attr('data-blink-times')}000`;
  const messageAfterCheck = $(".availabilityBar__message").attr('data-after-check');

  $('.availabilityBar__segment--orange').eq(1).addClass('availabilityBar__segment--blink');

  setTimeout(() => {
    $(".availabilityBar__message").text(messageAfterCheck);
    $('.availabilityBar__quantity').fadeIn();
  }, blinkTimeMS/2);

  setTimeout(() => {
    $('.availabilityBar__segment--orange').eq(1).fadeOut();
  }, blinkTimeMS);
}

function checkIsInViewport(element) {
  const elementTop = $(element).offset().top;
  const elementBottom = elementTop + $(element).outerHeight();
  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}